






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {TokenPush} from '@/model/resource/TokenPush'
import {InputTokenPushSchema} from '@/schema/resource/TokenPush/InputTokenPushSchema'

@Component
export default class PersistTokenPushView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputTokenPushSchema()
  tokenPush = new TokenPush()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionMotorista.listMotorista()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.tokenPush.getTokenPush(id)
    }

    $.await.done('getTokenPush')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.tokenPush.persistTokenPush()
    await Helper.successAndPush('system.success.persist', '/token-push/list')
  }
}
